import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = { class: "amenities-section my-4" };
const _hoisted_2 = { class: "card p-4" };
const _hoisted_3 = {
    key: 0,
    class: "amenities-grid"
};
const _hoisted_4 = { class: "h6 text-muted mb-2" };
const _hoisted_5 = { class: "list-unstyled m-0 amenities-list" };
const _hoisted_6 = {
    key: 1,
    class: "text-muted"
};
export default /*@__PURE__*/ _defineComponent({
    __name: 'GastronomyAmenitiesSection',
    props: {
        amenities: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "h5 mb-3" }, [
                        _createElementVNode("i", { class: "fas fa-handshake me-2" }),
                        _createTextVNode("Servicios ")
                    ], -1)),
                    (_ctx.amenities && _ctx.amenities.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.amenities, (group, idx) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: idx,
                                    class: "amenities-group"
                                }, [
                                    _createElementVNode("h4", _hoisted_4, _toDisplayString(group.title), 1),
                                    _createElementVNode("ul", _hoisted_5, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item, i) => {
                                            return (_openBlock(), _createElementBlock("li", { key: i }, [
                                                _cache[0] || (_cache[0] = _createElementVNode("i", { class: "fas fa-check text-success me-2" }, null, -1)),
                                                _createTextVNode(_toDisplayString(item), 1)
                                            ]));
                                        }), 128))
                                    ])
                                ]));
                            }), 128))
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_6, "Información."))
                ])
            ]));
        };
    }
});
